import { chipClasses } from '@mui/material';
import { Box } from '@mui/system';

export default function ChipContainer(props) {
    return (
        <Box
            sx={theme => ({
                mb: 2,
                pb: 2,
                px: 4,
                borderRadius: 2,
                bgcolor: 'common.lightblue',
                [`& .${chipClasses.root}`]: { mr: 2, mt: 2, bgcolor: 'common.lightgray', border: `1px solid ${theme.palette.common.gray}`, maxWidth: 'calc(100%-52px)' },
                [`& .${chipClasses.label}`]: { pb: '2px' },
                [theme.breakpoints.down('sm')]: { display: 'none' }
            })}
        >
            {props.children}
        </Box>
    );
}
